export const PATH_NAME = {
  // General routes
  ROOT: '/',
  ERROR_404: '/404',
  ERROR_403: '/403',
  TERM_CONDITION: '/terms-condition',
  SURVEY_TERM_CONDITION: '/diageo-terms-condition',
  PRIVACY_POLICY: '/privacy-policy',
  Contact_Us: '/contact-us',
  FAQ: '/faq',
  // Login routes
  PASSWORD_RESET: '/update-password',
  LOGIN: '/login',
  ADMIN_LOGIN: '/admin/login',

  // Cart routes
  PROFILE: '/profile',

  // Reward routes
  REWARDS: '/rewards',
  REWARDSBYCATEGORY: '/rewards/:categoryName',
  REWARD_DETAILS: '/rewards/:category/:rewardTitle',

  // Offers routes
  OFFERS: '/manage-rewards/offers',
  UPDATE_OFFERS: '/manage-rewards/offers/update',

  // Cart routes
  CART: '/cart',

  // Checkout routes
  CHECKOUT: '/checkout',

  //Dashboard
  DASHBOARD: '/dashboard',

  //Manage Reward Category
  MANAGE_REWARD_CATEGORY: '/dashboard/rewards-category',
  ADD_REWARD_CATEGORY: '/dashboard/rewards-category/add',
  UPDATE_REWARD_CATEGORY: '/dashboard/rewards-category/update',

  //Manage Customer
  MANAGE_CUSTOMERS: '/dashboard/manage-customers',
  ADD_CUSTOMER: '/dashboard/manage-customers/add',
  UPDATE_CUSTOMER: '/dashboard/manage-customers/update',
  CUSTOMERS_USER: '/dashboard/manage-customers/users',
  USER_DETAILS: '/dashboard/manage-customers/view',
  USER_UPDATE: '/dashboard/manage-customers/user/update',

  //Manage Campaign
  MANAGE_CAMPAIGNS: '/dashboard/manage-campaigns',
  ADD_CAMPAIGN: '/dashboard/manage-campaigns/add',
  UPDATE_CAMPAIGN: '/dashboard/manage-campaigns/update',
  SET_REWARDS: '/dashboard/manage-campaigns/set-rewards',

  //Manage Campaign
  MANAGE_REWARDS: '/dashboard/manage-rewards',
  ADD_REWARDS: '/dashboard/manage-rewards/add',
  UPDATE_REWARDS: '/dashboard/manage-rewards/update',

  //Redemption Code
  REDEMPTION_CODE: '/dashboard/manage-rewards/offers/redemption-code',
  UPDATE_CODE: '/dashboard/manage-rewards/offers/update-code',

  // Manage Mails
  MANAGE_MAIL_TEMPLATES: '/dashboard/setting/manage-template',
  ADD_MAIL_TEMPLATES: '/dashboard/setting/manage-template/add',
  UPDATE_MAIL_TEMPLATES: '/dashboard/setting/manage-template/:id',

  //ROLES - USERListing
  USER_LISTING: '/dashboard/setting/manage-user/users',
  ADD_USER: '/dashboard/setting/manage-user/users/add',
  UPDATE_USER: '/dashboard/setting/manage-user/:id',

  //Terms & condition
  ADD_TERMS: '/dashboard/terms/add',
  TERMS: '/dashboard/terms',
  UPDATE_TERMS: '/dashboard/terms/update',
  // Manage Privacy Policy
  ADD_PRIVACY_POLICY: '/dashboard/manage-privacy-policy/add',
  MANAGE_PRIVACY_POLICY: '/dashboard/manage-privacy-policy',
  UPDATE_PRIVACY_POLICY: '/dashboard/manage-privacy-policy/update',

  //Manage Permission
  MANAGE_PERMISSION: '/dashboard/permission',
  ADD_PERMISSION: '/dashboard/permission/add',
  UPDATE_PERMISSION: '/dashboard/permission/update',

  //Manage Permission
  ADHOC_REPORT: '/dashboard/adhoc-redemption-reports',
  ADD_ADHOC_REPORT: '/dashboard/adhoc-reports/add',

  REDEMPTION_REPORT: '/dashboard/redemption-reports',
  REDEMPTION_VIEW_REPORT: '/dashboard/reports-view',

  ADHOC_REWARDS_REPORT: '/dashboard/adhoc-rewards-reports',
  ADD_ADHOC_REWARDS_REPORT: '/dashboard/adhoc-rewards-reports/add',
  REWARDS_VIEW_REPORT: '/dashboard/rewards-reports-view',

  USER_ROLES: '/dashboard/roles',
  USER_ROLES_ADD: '/dashboard/roles/add',
  USER_ROLES_UPDATE: '/dashboard/roles/update',

  REDEMPTION_HISTORY: '/dashboard/redemptions',

  FAQS: '/dashboard/faqs',
  FAQS_ADD: '/dashboard/faq/add',
  FAQS_UPDATE: '/dashboard/faq/update',

  CUSTOM_IMAGES: '/dashboard/custom-images',
  CUSTOM_IMAGES_ADD: '/dashboard/custom-images/add',
  CUSTOM_IMAGES_UPDATE: '/dashboard/custom-images/update',
  CRICKET_REGISTRATION_CODES: '/dashboard/cricket-registration-code',

  SURVEY: '/survey',

  // cricket routes start here
  CRICKET_SIGNUP: '/signup',
  CRICKET_SIGNIN: '/signin',

  CRICKET_REWARDLIST: '/rewards',
  CRICKET_REWARD_DETAILS: '/rewards/:rewardTitle',
  CRICKET_PROFILE: '/profile',
  CRICKET_CART: '/cart',
  CRICKET_CHECKOUT: '/checkout',
  CRICKET_CONFIRMATION: '/confirmation',
  CRICKET_MYACCOUNT: '/myaccount',
  CRICKET_PASSWORD_RESET: '/reset-password',

  // USER_LISTING: '/dashboard/setting/manage-user/users',
  // UPDATE_USER: '/dashboard/setting/manage-user/:id',
};

export const pageLists = ['FAQS', 'CONTACT-US', 'VIEW-CART', 'THANKYOU-PAGE', 'FEATURE-REWARD', 'MY-ACCOUNT'];
